import React from 'react';
import { Asset } from '../../../types/asset';

interface FullWidthQuoteProps {
    quote: string;
    author: string;
    title: string;
    company: string;
    backgroundImage: Asset;
}

export const FullWidthQuote: React.FC<FullWidthQuoteProps> = ({
    quote,
    author,
    title,
    company,
    backgroundImage,
}) => {
    return (
        <div
            className={'px-2 xl:px-96 text-center text-white py-48 bg-cover bg-center'}
            style={{ backgroundImage: `url(${backgroundImage.url})` }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.333 95.332" className={'h-6 text-white fill-current mx-auto mb-12'}>
                <defs/>
                <path
                    d="M30.512 43.939c-2.348-.676-4.696-1.019-6.98-1.019-3.527 0-6.47.806-8.752 1.793 2.2-8.054 7.485-21.951 18.013-23.516a2.501 2.501 0 002.04-1.799l2.301-8.23a2.5 2.5 0 00-2.068-3.15 17.477 17.477 0 00-2.354-.16c-12.637 0-25.152 13.19-30.433 32.076-3.1 11.08-4.009 27.738 3.627 38.223 4.273 5.867 10.507 9 18.529 9.313l.098.002c9.898 0 18.675-6.666 21.345-16.209a22.032 22.032 0 00-2.032-16.851c-2.875-5.105-7.61-8.826-13.334-10.473zM92.471 54.413c-2.875-5.106-7.61-8.827-13.334-10.474-2.348-.676-4.696-1.019-6.979-1.019a21.94 21.94 0 00-8.753 1.793c2.2-8.054 7.485-21.951 18.014-23.516a2.503 2.503 0 002.04-1.799l2.301-8.23a2.5 2.5 0 00-2.068-3.15 17.455 17.455 0 00-2.354-.16c-12.637 0-25.152 13.19-30.434 32.076-3.099 11.08-4.008 27.738 3.629 38.225 4.272 5.866 10.507 9 18.528 9.312l.099.002c9.897 0 18.675-6.666 21.345-16.209a22.045 22.045 0 00-2.034-16.851z"
                />
            </svg>
            <p className={'font-playfair text-4xl leading-10'}>{quote}</p>
            <p className={'mt-8 text-sm'}>
                <span className={'font-bold'}>{author}</span> {title} - {company}
            </p>
        </div>
    );
};
